import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import Layout from '../components/Layout'

export default class IndexPage extends React.Component {
  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark

    return (
      <Layout>
        <section className="hero is-primary is-bold">
          <div className="hero-body">
            <div className="container">
              <h1 className="title">
                Bienvenue sur le site web du logiciel BoA
              </h1>
              <h2 className="subtitle">
                Logiciel 3D-2D pour l'architecture
              </h2>
              <p className="has-text-light">
                La version BoA 4.4 est maintenant disponible, vous pouvez la télécharger <a className="has-text-weight-bold" href="/fr/boa/downloads">ici</a>
              </p>
            </div>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="content">
              <h1 className="has-text-weight-bold is-size-2">Dernières nouvelles</h1>
            </div>
            {posts
              .map(({ node: post }) => (
                <div
                  className="content"
                  style={{ border: '1px solid #eaecee', padding: '2em 4em' }}
                  key={post.id}
                >
                  <p>
                    <Link className="has-text-primary" to={post.fields.slug}>
                      {post.frontmatter.title}
                    </Link>
                    <span> &bull; </span>
                    <small>{post.frontmatter.date}</small>
                  </p>
                  <p>
                    {post.excerpt}
                    <br />
                    <br />
                    <Link className="button is-small" to={post.fields.slug}>
                      Lire la suite →
                    </Link>
                  </p>
                </div>
              ))}
          </div>
        </section>
      </Layout>
    )
  }
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexQuery_fr {
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] },
      filter: { 
        frontmatter: { templateKey: { eq: "blog-post" } },
        fields: { langKey: { eq: "fr" }}
      }
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
            langKey
          }
          frontmatter {
            title
            templateKey
            date(
              formatString: "DD MMMM YYYY",
              locale: "fr"
            )
          }
        }
      }
    }
  }
`
